import useRecommendedFilterManager from '@/src/hooks/srp/recommendedFilterManager'
import { Box, Checkbox, Divider, FormControlLabel, Typography } from '@mui/material'

const RecommendedFilterWrapper = () => {
    const { recommendedFilterOptions, title, isMulticity, appliesToAllJourneysLabel } = useRecommendedFilterManager(0)
    return (
        <Box>
            <Box
                sx={{
                    width: '100%',
                    px: 2,
                    py: 1,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                }}
            >
                <Typography
                    variant="subtitle2"
                    sx={{
                        fontSize: '0.875rem',
                        fontWeight: 600,
                        color: 'text.primary'
                    }}
                >
                    {title}
                </Typography>
                {isMulticity ? (
                    <Typography
                        variant="caption"
                        sx={{
                            display: 'block',
                            fontSize: '0.75rem',
                            color: 'text.secondary'
                        }}
                    >
                        ( {appliesToAllJourneysLabel})
                    </Typography>
                ) : null}
            </Box>

            {/* Filter Options */}
            <Box sx={{ px: 0.5 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    {recommendedFilterOptions?.map(option =>
                        option.show ? (
                            <FormControlLabel
                                key={option.id}
                                control={
                                    <Checkbox
                                        checked={option.checked}
                                        onChange={option.onClick}
                                        sx={{
                                            color: 'grey.400',
                                            '&.Mui-checked': {
                                                color: 'primary.main'
                                            },
                                            '&:hover': {
                                                backgroundColor: 'transparent'
                                            }
                                        }}
                                    />
                                }
                                label={
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <option.icon sx={{ fontSize: 17, color: 'text.secondary', mr: 0.7 }} />
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontSize: '0.875rem',
                                                fontWeight: '600',
                                                color: '#333333'
                                            }}
                                        >
                                            {option.label}
                                        </Typography>
                                    </Box>
                                }
                                sx={{
                                    m: 0,
                                    cursor: 'pointer',
                                    height: '32px'
                                }}
                            />
                        ) : null
                    )}
                </Box>
            </Box>
            <Divider />
        </Box>
    )
}

export default RecommendedFilterWrapper
